import { render, staticRenderFns } from "./MarsDATAInfo.vue?vue&type=template&id=2ce89b1f&scoped=true&"
import script from "./MarsDATAInfo.vue?vue&type=script&lang=js&"
export * from "./MarsDATAInfo.vue?vue&type=script&lang=js&"
import style0 from "./MarsDATAInfo.vue?vue&type=style&index=0&id=2ce89b1f&lang=scss&scoped=true&"
import style1 from "./MarsDATAInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce89b1f",
  null
  
)

export default component.exports